





























/* global HLS */
import Vue from 'vue'
import { firestore, functions } from '../firebase'

export default Vue.extend({
  name: "StreamPage",
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      stream: null as null | { [key:string]: any }
    }
  },
  created() {
    firestore.doc(`streams/${this.id}`).get().then(doc => {
      const stream: { [key: string]: any } = {...doc.data(), _id: doc.id } || {}
      this.stream = stream
      if (stream && stream._streamTarget === "default") {
        const liveStream = functions.httpsCallable('liveStream')
        // @ts-ignore
        if (Hls.isSupported()) {
          window.console.log('Hls supported.')
          let video

          const waitForVideo = setInterval(() => {
            window.console.log('waiting for video element')
            video = document.getElementById('muxVideo')
            if (video) {
              window.console.log('video element found')

              // @ts-ignore
              const hls = new Hls()
              hls.loadSource(`https://stream.mux.com/${stream._muxPlaybackId}.m3u8`)
              hls.attachMedia(video)
              window.console.log('calling liveStream Functions')
              liveStream({ _id: stream._id }).then(result => {
                window.console.log(result)
              }).catch(err => {
                window.console.error(err)
              })
              clearInterval(waitForVideo)
            }
          }, 500)
          

        }
        
      }
    })
    
  },

  mounted() {
    const stream = this.stream
    
    
  }
})
